// extracted by mini-css-extract-plugin
export default {"fs":"_549c2869bb _2014128d00"};